import { Component } from '@angular/core';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Authentication } from '../../../providers/authentication';
import { SECRETS } from '../../../constants';

@Component({
    selector: 'facebook-login',
    templateUrl: './facebook_login.pug'
})

export class FacebookLoginComponent {
  constructor(public authService: Authentication,
              public toastr: ToastsManager) {
  }

  public facebookLogin() {
    this.configFB();
    FB.login((response: any) => {
      if (response['authResponse']) {
        this.authenticateUser(response);
      }
    }, {scope: 'email'});
  }

  private configFB() {
    FB.init({
      appId      : SECRETS['facebook_app_id'],
      cookie     : false,
      xfbml      : true,
      version    : 'v2.9'
    });
  }

  private authenticateUser(res: Object) {
    this.authService.facebookAuth(res['authResponse'].accessToken).subscribe((data) => {
      this.authService.setUser(data);
    }, (err) => {
      this.toastr.info('Sign in failed!');
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/+utils/facebook_login/facebook_login.ts